




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ToggleButton extends Vue {
  @Prop({ required: true }) private readonly firstName!: string;

  @Prop({ required: true }) private readonly secondName!: string;

  @Prop({ required: true }) private readonly selected!: string;

  private get overlayPosition() {
    const transform = this.selected === this.firstName ? 'translateX(0px)' : 'translateX(100%)';
    return {
      transform,
    };
  }

  private onClick(buttonName: string): void {
    if (buttonName !== this.selected) {
      this.$emit('change', buttonName);
    }
  }
}
